import React from 'react';
import ProjecteIdValidacionsUnified from '../../projecteId/content/ProjecteIdValidacions';

const ProjecteIdValidacions = () => {
    return <ProjecteIdValidacionsUnified />;
};

export default ProjecteIdValidacions;
